import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, } from "react";
// components
import { StyledWrapper } from "../common/Wrapper.styles";
import { ErrorLabel } from "../common/Error.styles";
import { Label } from "../common/Label.styles";
import { TextFieldStyle, CharactersInfo, Grow } from "./TextField.styles";
// utils
import { makeDataTestIdGetter } from "../../utils";
export const TextField = ({ onChange, onBlur, errorMessage, errors, name, values, label, placeholder, readOnly, required, disabled, defaultValue, inputValue, min, max, hasCharacterCount, autoHeight, previewId, dataTestIdPrefix, }) => {
    const [focused, setFocused] = useState(false);
    const [selected, setSelected] = useState(false);
    const [characters, setCharacters] = useState(0);
    const getDataTestId = makeDataTestIdGetter(dataTestIdPrefix);
    useEffect(() => {
        if (hasCharacterCount) {
            setCharacters((values === null || values === void 0 ? void 0 : values[name].length) || 0);
        }
    }, []);
    function handleChange(e) {
        onChange(e);
        if (hasCharacterCount) {
            setCharacters(e.currentTarget.value.length);
        }
    }
    return (_jsx(_Fragment, { children: _jsxs(StyledWrapper, Object.assign({ values: values, name: name }, { children: [label && (_jsxs(Label, Object.assign({ htmlFor: name }, { children: [label, label && required && "*"] }))), hasCharacterCount && (_jsxs(CharactersInfo, Object.assign({ error: errors === null || errors === void 0 ? void 0 : errors[name], currentValue: values === null || values === void 0 ? void 0 : values[name] }, { children: [characters, "/", max] }))), _jsx(Grow, Object.assign({ "data-replicated-value": defaultValue || inputValue || (values === null || values === void 0 ? void 0 : values[name]), autoHeight: autoHeight }, { children: _jsx(TextFieldStyle, { "data-preview-id": previewId, id: name, tabIndex: disabled || readOnly ? -1 : 0, readOnly: readOnly, placeholder: placeholder, focused: focused, selected: selected, onFocus: () => setSelected(true), onChange: handleChange, minLength: min, maxLength: max, autoHeight: autoHeight, onMouseDown: () => {
                            setFocused(false);
                            setSelected(false);
                        }, onKeyUp: (e) => {
                            if (e.key === "Tab")
                                setFocused(true);
                            setSelected(true);
                        }, onBlur: (e) => {
                            setFocused(false);
                            setSelected(false);
                            if (onBlur)
                                onBlur(e);
                        }, errors: errors, value: defaultValue || inputValue || (values === null || values === void 0 ? void 0 : values[name]), disabled: disabled, name: name, "data-testid": getDataTestId("textfield-input") }) })), (errors === null || errors === void 0 ? void 0 : errors[name]) && (_jsx(ErrorLabel, { children: errorMessage || errors[name] }))] })) }));
};
